import { Box, Button, Column, Switch, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Links } from '~/constants';
import type { ISignUpFormValues } from '../../types';
import { PSA_DESCRIPTION } from '../constants';

export const PsaSection = () => {
  const { control } = useFormContext<ISignUpFormValues>();
  const workerType = useWatch({ control, name: 'workerType' });

  if (workerType !== 'employee') return null;

  return (
    <Box style={{ marginTop: 8, marginBottom: 4 }}>
      <Typography
        as="h2"
        bold
        color={colors.neutral[600]}
        textAlign="center"
        style={{ fontSize: 18, margin: 0, marginBottom: 12 }}
      >
        Personnel Service Agreement
      </Typography>
      <Typography size="body_large" color={colors.neutral[600]} style={{ marginBottom: 28 }}>
        {PSA_DESCRIPTION}
      </Typography>
      <Controller
        name="psaAccepted"
        control={control}
        rules={{
          validate: (value, values) => values.workerType !== 'employee' || value === true,
        }}
        render={({ field, fieldState }) => (
          <Column align="center" gap={1}>
            <Switch
              data-cy="switch-psa-accepted"
              checked={field.value}
              onChange={field.onChange}
              error={Boolean(fieldState.error)}
              label={
                <Typography as="span" color={colors.neutral[600]}>
                  I agree to GoTu’s
                  <Button
                    data-cy="link-psa"
                    type="button"
                    variant="ghost"
                    size="inline"
                    style={{ fontSize: 18 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(Links.termsOfUseEmployee, '_blank', 'noopener,noreferrer');
                    }}
                  >
                    Personnel Service Agreement
                  </Button>
                </Typography>
              }
            />
          </Column>
        )}
      />
    </Box>
  );
};
